// src/components/Card.jsx
import { Box, Flex, Heading } from "@chakra-ui/react";

/**
 * Card
 * A reusable wrapper component for cockpit modules.
 * - Provides consistent styling (light/dark mode, padding, rounded corners, shadow).
 * - Supports optional title and actions in the header.
 *
 * Props:
 * - children: React nodes inside the card body
 * - title: optional string for card heading
 * - actions: optional React nodes (e.g., buttons) rendered in the header
 */
export default function Card({ children, title, actions, ...props }) {
  return (
    <Box
      bg="white"
      _dark={{ bg: "gray.800" }}
      p={{ base: 4, md: 6 }}
      rounded="md"
      shadow="md"
      w="full"
      {...props}
    >
      {(title || actions) && (
        <Flex justify="space-between" align="center" mb={4}>
          {title && (
            <Heading as="h2" size="sm" fontWeight="600">
              {title}
            </Heading>
          )}
          {actions && <Flex gap={2}>{actions}</Flex>}
        </Flex>
      )}
      {children}
    </Box>
  );
}
